module.exports = __webpack_public_path__ + "img/banner.77009933.png";